/* ============================================================
   DS RAIL — mouse click-and-drag for ds-group's swipeable rail

   The rail itself (blocks/ds-group.liquid, ds-content.css) is native
   scroll-snap with no JavaScript, same as the DS source
   (DS/explorations/homepage/homepage-q4-evergreen-mobile/rail.js):
   touch swiping, momentum, snapping and keyboard scrolling all come
   from the browser. The one thing the browser does NOT give is mouse
   dragging — a mouse can only scroll it with a trackpad gesture or
   shift+wheel. This adds exactly that, and nothing else:

   - MOUSE ONLY (`pointerType === 'mouse'`). Touch and pen keep the
     browser's own native scrolling untouched.
   - NO-OP WHEN THE RAIL CAN'T SCROLL. At 990px+ the rail reverts to an
     ordinary grid (ds-content.css), so there's nothing to drag.
   - A DRAG NEVER BECOMES A CLICK. Cards are whole-tile links; once the
     pointer has moved past the threshold, the click that follows
     pointerup is swallowed so letting go doesn't navigate.
   - SNAP IS SUSPENDED WHILE DRAGGING (.ds-group--dragging in
     ds-content.css) — otherwise snap fights every scrollLeft write —
     and restored on release, which lets the browser settle on the
     nearest card itself.

   Not in the DS source: its rail is deliberately behavior-free at the
   exploration stage. Document-level delegation, so it covers every
   rail on the page — including ones added later by the Theme Editor —
   and a guard so loading it once per rail is harmless.
   ============================================================ */

(() => {
  if (window.dsRailDrag) return;
  window.dsRailDrag = true;

  const DRAG_THRESHOLD = 5;

  let rail = null;
  let startX = 0;
  let startScroll = 0;
  let dragged = false;
  let suppressClick = false;

  document.addEventListener('pointerdown', (event) => {
    if (event.pointerType !== 'mouse' || event.button !== 0) return;
    const target = event.target.closest('.ds-group--rail');
    if (!target || target.scrollWidth <= target.clientWidth) return;

    rail = target;
    startX = event.clientX;
    startScroll = rail.scrollLeft;
    dragged = false;
  });

  document.addEventListener('pointermove', (event) => {
    if (!rail) return;
    const dx = event.clientX - startX;

    if (!dragged) {
      if (Math.abs(dx) < DRAG_THRESHOLD) return;
      dragged = true;
      rail.classList.add('ds-group--dragging');
      window.getSelection()?.removeAllRanges();
    }

    rail.scrollLeft = startScroll - dx;
  });

  const endDrag = () => {
    if (!rail) return;
    if (dragged) {
      rail.classList.remove('ds-group--dragging');
      suppressClick = true;
      // If no click follows (pointer released outside a link), don't
      // leave the flag set for the next unrelated click.
      setTimeout(() => {
        suppressClick = false;
      }, 0);
    }
    rail = null;
  };

  document.addEventListener('pointerup', endDrag);
  document.addEventListener('pointercancel', endDrag);

  document.addEventListener(
    'click',
    (event) => {
      if (!suppressClick) return;
      suppressClick = false;
      event.preventDefault();
      event.stopPropagation();
    },
    true
  );

  // Native image/link drag-and-drop would otherwise hijack the gesture
  // (the browser starts dragging the card's <img> or <a> as a file/URL).
  document.addEventListener('dragstart', (event) => {
    if (event.target.closest?.('.ds-group--rail')) event.preventDefault();
  });
})();
